document.addEventListener("DOMContentLoaded", function () {
  /**
   * Video popup
   */
  document.querySelectorAll(".wwa-item-video").forEach((videocontainer) => {
    const videoPopup = videocontainer.querySelector(".wwa-videopopup");
    const videoBtn = videocontainer.querySelector(".wwa-videobtn");
    const closeBtn = videocontainer.querySelector(".wwa-videoclosebtn");
    const overlay = videocontainer.querySelector(".videopopup-overlay");
    const videoContainer = videocontainer.querySelector(".video-wp");
    const video = videoContainer ? videoContainer.querySelector("video") : null;
    const iframe = videoContainer ? videoContainer.querySelector("iframe") : null;

    if (!videoPopup || !videoBtn) return;

    function openPopup() {
      videoPopup.classList.add("active");

      if (video) {
        video.play().catch(() => {});
      } else if (iframe) {
        let src = iframe.getAttribute("src") || "";

        if (!src.includes("autoplay=1")) {
          iframe.setAttribute("src", src + (src.includes("?") ? "&" : "?") + "autoplay=1");
        }
      }
    }

    function closePopup() {
      videoPopup.classList.remove("active");

      if (video) {
        video.pause();
        video.currentTime = 0;
      } else if (iframe) {
        let src = iframe.getAttribute("src") || "";
        iframe.setAttribute("src", "");
        iframe.setAttribute("src", src.replace("autoplay=1", "autoplay=0"));
      }
    }

    videoBtn.addEventListener("click", openPopup);

    if (closeBtn) {
      closeBtn.addEventListener("click", closePopup);
    }

    if (overlay) {
      overlay.addEventListener("click", closePopup);
    }
  });

  /**
   * Video mute / unmute
   */
  document.querySelectorAll(".wwa-video-mute-unmutebtn").forEach((button) => {
    button.addEventListener("click", function () {
      const videoWrapper = this.closest(".video-wp");
      if (!videoWrapper) return;

      const video = videoWrapper.querySelector("video");
      if (!video) return;

      video.muted = !video.muted;
      this.classList.toggle("muted", video.muted);
    });
  });

  /**
   * Video play / pause
   */
  document.querySelectorAll(".wwa-video-pause-playbtn").forEach((button) => {
    button.addEventListener("click", function () {
      const videoWrapper = this.closest(".video-wp");
      if (!videoWrapper) return;

      const video = videoWrapper.querySelector("video");
      if (!video) return;

      if (video.paused) {
        video.play().catch(() => {});
        this.classList.add("playing");
      } else {
        video.pause();
        this.classList.remove("playing");
      }
    });
  });

  /**
   * CF accordion
   */
  document.querySelectorAll(".cf-grid").forEach((grid) => {
    const triggers = grid.querySelectorAll(".cf-trigger");

    triggers.forEach((trigger) => {
      trigger.addEventListener("click", function () {
        const content = this.nextElementSibling;
        if (!content) return;

        const isOpen = content.classList.contains("open");

        grid.querySelectorAll(".cf-trigger").forEach((t) => t.classList.remove("open"));

        grid.querySelectorAll(".cf-content").forEach((c) => {
          c.style.maxHeight = "0";
          c.classList.remove("open");
        });

        if (!isOpen) {
          this.classList.add("open");
          content.classList.add("open");
          content.style.maxHeight = content.scrollHeight + "px";
        }
      });
    });
  });

  /**
   * Bundled CF accordion
   */
  document.querySelectorAll(".cf-grid-bundled").forEach((grid) => {
    const triggersBundled = grid.querySelectorAll(".cf-trigger-bundled");

    triggersBundled.forEach((trigger) => {
      trigger.addEventListener("click", function () {
        const content = this.nextElementSibling;
        if (!content) return;

        const isOpen = content.classList.contains("open");

        grid.querySelectorAll(".cf-trigger-bundled").forEach((t) => t.classList.remove("open"));

        grid.querySelectorAll(".cf-content-bundled").forEach((c) => {
          c.style.maxHeight = "0";
          c.classList.remove("open");
        });

        if (!isOpen) {
          this.classList.add("open");
          content.classList.add("open");
          content.style.maxHeight = content.scrollHeight + "px";
        }
      });
    });
  });

  /**
   * Custom dropdown variants
   */
  const checkTemplate = document.body.dataset.template;

  document.querySelectorAll(".custom-dropdown").forEach((dropdown) => {
    const idInput = dropdown.querySelector('[name="id"]');
    const addToCartForm = dropdown.closest("form");
    const addToCartButton = addToCartForm ? addToCartForm.querySelector('[name="add"]') : null;
    const addToCartButtonText = addToCartButton ? addToCartButton.querySelector(".quickaddbtntext") : null;
    const button = dropdown.querySelector(".custom-dropdown-btn");
    const content = dropdown.querySelector(".custom-dropdown-content");
    const items = dropdown.querySelectorAll(".custom-dropdown-content li");

    if (!button || !content || !items.length) return;

    let productContainer = null;

    if (checkTemplate === "product") {
      productContainer = dropdown.closest(".product__info-container");
    }

    button.addEventListener("click", (event) => {
      event.stopPropagation();

      document.querySelectorAll(".custom-dropdown-content.show").forEach((drop) => {
        if (drop !== content) {
          drop.classList.remove("show");
        }
      });

      content.classList.toggle("show");
    });

    items.forEach((item) => {
      item.addEventListener("click", (event) => {
        event.preventDefault();

        if (idInput && item.dataset.varid) {
          const oldValue = idInput.value;
          idInput.value = item.dataset.varid;

          if (oldValue !== item.dataset.varid) {
            document.dispatchEvent(
              new CustomEvent("variant:change", {
                detail: {
                  variantId: item.dataset.varid,
                  variant: { id: item.dataset.varid },
                  previousVariantId: oldValue
                }
              })
            );
          }
        }

        if (addToCartForm && addToCartButton && addToCartButtonText && window.variantStrings) {
          if (item.dataset.variant_available === "false") {
            addToCartButton.disabled = true;
            addToCartButtonText.textContent = window.variantStrings.soldOut;
          } else {
            addToCartButton.disabled = false;
            addToCartButtonText.textContent = window.variantStrings.addToCart;
          }
        }

        if (checkTemplate === "product" && productContainer) {
          ["option1", "option2", "option3"].forEach((opt) => {
            const value = item.dataset[opt];

            if (value) {
              const optionEvent = productContainer.querySelector(`[data-${opt}] [data-${opt}="${value}"]`);

              if (optionEvent) {
                optionEvent.click();
              }
            }
          });
        }

        button.innerHTML = item.innerHTML;
        content.classList.remove("show");
      });
    });
  });

  /**
   * Close custom dropdowns when clicking outside
   */
  document.addEventListener("click", () => {
    document.querySelectorAll(".custom-card .custom-dropdown-content.show").forEach((drop) => {
      drop.classList.remove("show");
    });
  });

  /**
   * Product banner highlights
   */
  document.querySelectorAll(".product_banner_highlights-main").forEach((highlights) => {
    const buttons = highlights.querySelectorAll(".pbh-btn");
    const images = highlights.querySelectorAll(".pbh-img-wp");

    if (!buttons.length || !images.length) return;

    let currentIndex = 0;
    let interval;

    const activateButton = (index) => {
      buttons.forEach((btn, i) => {
        btn.classList.toggle("active", i === index);
      });

      images.forEach((img, i) => {
        img.classList.toggle("active", i === index);
      });
    };

    const startRotation = () => {
      clearInterval(interval);

      interval = setInterval(() => {
        currentIndex = (currentIndex + 1) % buttons.length;
        activateButton(currentIndex);
      }, 3000);
    };

    buttons.forEach((button, index) => {
      button.addEventListener("mouseenter", () => {
        clearInterval(interval);
        currentIndex = index;
        activateButton(currentIndex);
      });

      button.addEventListener("mouseleave", startRotation);
    });

    activateButton(currentIndex);
    startRotation();
  });

  /**
   * Safe Flickity init
   * Prevents collection pages from breaking when .product__media-list does not exist.
   */
  function initFlickity(selector, options) {
    if (typeof Flickity === "undefined") return;

    document.querySelectorAll(selector).forEach((element) => {
      if (!element) return;
      if (element.classList.contains("flickity-enabled")) return;

      new Flickity(element, options);
    });
  }

  initFlickity(".product__media-list", {
    freeScroll: false,
    cellAlign: "left",
    contain: true,
    prevNextButtons: true,
    pageDots: true,
    wrapAround: true
  });

  /**
   * Back to top
   */
  document.addEventListener("click", function (e) {
    const btn = e.target.closest(".ps-backtotop-btn");
    if (!btn) return;

    e.preventDefault();

    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  });
});

/**
 * Footer mobile accordion
 */
(function () {
  function setupFooterAccordion() {
    const isMobile = window.innerWidth <= 768;

    document.querySelectorAll(".footer-block--menu").forEach((block) => {
      const heading = block.querySelector(".footer-block__heading");
      const content = block.querySelector(".footer-block__details-content");

      if (!heading || !content) return;

      if (heading._clickHandler) {
        heading.removeEventListener("click", heading._clickHandler);
      }

      content.style.maxHeight = "";
      content.style.overflow = "";
      content.style.transition = "";
      heading.style.cursor = "";

      if (isMobile) {
        content.style.maxHeight = "0px";
        content.style.overflow = "hidden";
        content.style.transition = "max-height 0.3s ease";
        heading.style.cursor = "pointer";

        const handler = function () {
          const isOpen = content.style.maxHeight !== "0px";

          document.querySelectorAll(".footer-block--menu .footer-block__details-content").forEach((el) => {
            el.style.maxHeight = "0px";
          });

          if (!isOpen) {
            content.style.maxHeight = content.scrollHeight + "px";
          }
        };

        heading._clickHandler = handler;
        heading.addEventListener("click", handler);
      }
    });
  }

  document.addEventListener("DOMContentLoaded", setupFooterAccordion);
  document.addEventListener("shopify:section:load", setupFooterAccordion);

  let resizeTimer;

  window.addEventListener("resize", function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(setupFooterAccordion, 200);
  });
})();

/**
 * Cart drawer trigger fix
 * Forces cart icon/header cart links to open the cart drawer instead of going to /cart.
 */
(function () {
  function setupCartDrawerTrigger() {
    const cartDrawer = document.querySelector("cart-drawer");

    if (!cartDrawer) return;

    const cartTriggers = document.querySelectorAll(
      '#cart-icon-bubble, .header__icon--cart, a[href="/cart"], a[href*="/cart"]'
    );

    cartTriggers.forEach((trigger) => {
      if (trigger.dataset.cartDrawerBound === "true") return;

      trigger.dataset.cartDrawerBound = "true";

      trigger.addEventListener("click", function (event) {
        const isInsideDrawer = trigger.closest("cart-drawer");
        const isCheckoutButton = trigger.href && trigger.href.includes("/checkout");

        if (isInsideDrawer || isCheckoutButton) return;

        event.preventDefault();

        if (typeof cartDrawer.open === "function") {
          cartDrawer.open(trigger);
        } else {
          cartDrawer.classList.add("animate", "active");
          document.body.classList.add("overflow-hidden");
        }
      });
    });
  }

  document.addEventListener("DOMContentLoaded", setupCartDrawerTrigger);
  document.addEventListener("shopify:section:load", setupCartDrawerTrigger);
})();

/**
 * Collection Add to Cart Drawer Fix V2
 * Handles collection/product card Add to Cart clicks and opens the drawer.
 */
(function () {
  if (window.psCollectionCartDrawerFixLoadedV2) return;
  window.psCollectionCartDrawerFixLoadedV2 = true;

  const pendingForms = new WeakSet();

  function isCartAddForm(form) {
    if (!(form instanceof HTMLFormElement)) return false;

    const action = form.getAttribute("action") || "";

    return action.includes("/cart/add") || form.querySelector('[name="id"]');
  }

  function isCollectionCardForm(form) {
    if (!form) return false;

    if (form.closest("#MainProduct")) return false;

    return !!(
      form.closest("#ProductGridContainer") ||
      form.closest("#product-grid") ||
      form.closest(".collection") ||
      form.closest(".collection__products") ||
      form.closest(".card-wrapper") ||
      form.closest(".grid__item") ||
      form.closest(".custom-card")
    );
  }

  async function addToCartAndOpenDrawer(form, submitButton) {
    if (pendingForms.has(form)) return;

    pendingForms.add(form);

    const cartDrawer = document.querySelector("cart-drawer");
    const button = submitButton || form.querySelector('[type="submit"], [name="add"]');

    if (button) {
      button.setAttribute("aria-disabled", "true");
      button.classList.add("loading");
    }

    try {
      const formData = new FormData(form);

      if (cartDrawer && typeof cartDrawer.getSectionsToRender === "function") {
        formData.append(
          "sections",
          cartDrawer.getSectionsToRender().map((section) => section.id)
        );
        formData.append("sections_url", window.location.pathname);
      }

      const response = await fetch(
        (window.routes && window.routes.cart_add_url) || "/cart/add.js",
        {
          method: "POST",
          headers: {
            "X-Requested-With": "XMLHttpRequest",
            Accept: "application/json"
          },
          body: formData
        }
      );

      const parsedState = await response.json();

      if (!response.ok || parsedState.status) {
        throw new Error(parsedState.description || "Could not add item to cart.");
      }

      if (cartDrawer) {
        cartDrawer.classList.remove("is-empty");

        if (typeof cartDrawer.renderContents === "function" && parsedState.sections) {
          cartDrawer.renderContents(parsedState);
        }

        if (typeof cartDrawer.open === "function") {
          setTimeout(function () {
            cartDrawer.open(button || form);
          }, 150);
        } else {
          cartDrawer.classList.add("animate", "active");
          document.body.classList.add("overflow-hidden");
        }
      } else {
        window.location.href = (window.routes && window.routes.cart_url) || "/cart";
      }

      document.dispatchEvent(
        new CustomEvent("cart:refresh", {
          detail: parsedState
        })
      );
    } catch (error) {
      console.error("Collection add to cart error:", error);
      window.location.href = (window.routes && window.routes.cart_url) || "/cart";
    } finally {
      pendingForms.delete(form);

      if (button) {
        button.removeAttribute("aria-disabled");
        button.classList.remove("loading");
      }
    }
  }

  document.addEventListener(
    "click",
    function (event) {
      const button = event.target.closest(
        'form[action*="/cart/add"] [type="submit"], form[action*="/cart/add"] [name="add"], form button[name="add"]'
      );

      if (!button) return;

      const form = button.closest("form");

      if (!isCartAddForm(form)) return;
      if (!isCollectionCardForm(form)) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      addToCartAndOpenDrawer(form, button);
    },
    true
  );

  document.addEventListener(
    "submit",
    function (event) {
      const form = event.target;

      if (!isCartAddForm(form)) return;
      if (!isCollectionCardForm(form)) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      addToCartAndOpenDrawer(form);
    },
    true
  );
})();

/**
 * PDP Add to Cart Drawer Fix V2
 * Handles PDP buttons that are inside OR outside the product form.
 */
(function () {
  if (window.psPdpCartDrawerFixLoadedV2) return;
  window.psPdpCartDrawerFixLoadedV2 = true;

  const pendingForms = new WeakSet();

  function getFormFromButton(button) {
    if (!button) return null;

    const closestForm = button.closest("form");

    if (closestForm) return closestForm;

    const formId = button.getAttribute("form");

    if (formId) {
      const linkedForm = document.getElementById(formId);
      if (linkedForm) return linkedForm;
    }

    return document.querySelector(
      '#MainProduct form[action*="/cart/add"], #MainProduct form[data-type="add-to-cart-form"], #MainProduct form[action*="/cart/add.js"]'
    );
  }

  function isPdpAddToCartForm(form) {
    if (!(form instanceof HTMLFormElement)) return false;

    const mainProduct = document.querySelector("#MainProduct");
    const action = form.getAttribute("action") || "";

    if (!mainProduct) return false;

    const isProductForm =
      mainProduct.contains(form) ||
      form.id.includes("product-form") ||
      form.dataset.type === "add-to-cart-form";

    const isCartAdd =
      action.includes("/cart/add") ||
      action.includes("/cart/add.js") ||
      form.querySelector('[name="id"]');

    return isProductForm && isCartAdd;
  }

  async function addPdpItemToCartAndOpenDrawer(form, submitButton) {
    if (!form || pendingForms.has(form)) return;

    pendingForms.add(form);

    const cartDrawer = document.querySelector("cart-drawer");
    const button = submitButton || form.querySelector('[type="submit"], [name="add"]');

    if (button) {
      button.setAttribute("aria-disabled", "true");
      button.classList.add("loading");
    }

    try {
      const formData = new FormData(form);

      if (cartDrawer && typeof cartDrawer.getSectionsToRender === "function") {
        formData.append(
          "sections",
          cartDrawer.getSectionsToRender().map((section) => section.id)
        );
        formData.append("sections_url", window.location.pathname);
      }

      const response = await fetch(
        (window.routes && window.routes.cart_add_url) || "/cart/add.js",
        {
          method: "POST",
          headers: {
            "X-Requested-With": "XMLHttpRequest",
            Accept: "application/json"
          },
          body: formData
        }
      );

      const parsedState = await response.json();

      if (!response.ok || parsedState.status) {
        throw new Error(parsedState.description || "Could not add item to cart.");
      }

      if (cartDrawer) {
        cartDrawer.classList.remove("is-empty");

        if (typeof cartDrawer.renderContents === "function" && parsedState.sections) {
          cartDrawer.renderContents(parsedState);
        }

        if (typeof cartDrawer.open === "function") {
          setTimeout(function () {
            cartDrawer.open(button || form);
          }, 150);
        } else {
          cartDrawer.classList.add("animate", "active");
          document.body.classList.add("overflow-hidden");
        }
      } else {
        window.location.href = (window.routes && window.routes.cart_url) || "/cart";
      }

      document.dispatchEvent(
        new CustomEvent("cart:refresh", {
          detail: parsedState
        })
      );
    } catch (error) {
      console.error("PDP add to cart error:", error);
      alert(error.message || "Could not add item to cart.");
    } finally {
      pendingForms.delete(form);

      if (button) {
        button.removeAttribute("aria-disabled");
        button.classList.remove("loading");
      }
    }
  }

  document.addEventListener(
    "click",
    function (event) {
      const button = event.target.closest(
        '#MainProduct .product-form__submit, #MainProduct button[name="add"], #MainProduct [type="submit"][form], #MainProduct [type="submit"]'
      );

      if (!button) return;

      const form = getFormFromButton(button);

      if (!isPdpAddToCartForm(form)) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      addPdpItemToCartAndOpenDrawer(form, button);
    },
    true
  );

  document.addEventListener(
    "submit",
    function (event) {
      const form = event.target;

      if (!isPdpAddToCartForm(form)) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      addPdpItemToCartAndOpenDrawer(form);
    },
    true
  );
})();